import { createSlice } from '@reduxjs/toolkit';
import { createAsyncThunkWrapper } from 'redux/thunk/createAsyncThunkWrapper';

export interface merchantBalance {
    balance: number;
    loading: boolean;
    error: string | null;
}
const initialState: merchantBalance = {
    balance: 0,
    loading: false,
    error: null,
};

/** Phase 12 — static Freeze: no legacy getCustomReport. */
export const fetchMerchantBalance = createAsyncThunkWrapper('merchantBalance/fetchMerchantBalance', async () => {
    return { total: 0 };
});

const merchantBalanceSlice = createSlice({
    name: 'merchantBalance',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchMerchantBalance.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchMerchantBalance.fulfilled, (state, action) => {
            state.loading = false;
            if (!action?.payload) return;
            const { total } = action?.payload;
            state.balance = total || 0;
        });
        builder.addCase(fetchMerchantBalance.rejected, (state, action) => {
            state.loading = false;
            state.error = action?.error?.message || null;
        });
    },
});
export default merchantBalanceSlice.reducer;
